import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AttachmentService} from '@core/services';
import {FileWidget} from '@core/components';

@Component({
  selector: 'core-attachment-uploader',
  imports: [
    FileWidget
  ],
  templateUrl: './attachment-uploader.html',
  styleUrl: './attachment-uploader.scss',
  standalone: true,
  host: {
    style: 'width: 100%;display: flex;flex-direction: column;gap: 1rem;'
  }
})
export class AttachmentUploader {
  @Input() companyId: string = '';
  @Input() relatedToType: string = '';
  @Input() relatedToId: string | number | null = null;
  @Input() token: string | null = null;
  @Input() allowAudio: boolean = true;
  @Input() allowFiles: boolean = true;
  @Input() autoUpload: boolean = false;
  @Output() uploaded = new EventEmitter<void>();

  attachedFiles: File[] = [];
  audioFile: File | null = null;
  errorMessage: string = '';
  isUploading: boolean = false;

  constructor(private attachmentService: AttachmentService) {}

  handleAttachFiles(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files) return;

    this.attachedFiles = [...this.attachedFiles, ...Array.from(input.files)];
    input.value = '';

    if (this.autoUpload) {
      void this.uploadAll();
    }
  }

  handleAudioFile(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files || !input.files.length) return;
    this.audioFile = input.files[0];
    input.value = '';

    if (this.autoUpload) {
      void this.uploadAll();
    }
  }

  removeAttachment(index: number) {
    this.attachedFiles = this.attachedFiles.filter((_, idx) => idx !== index);
  }

  removeAudio() {
    this.audioFile = null;
  }

  async uploadAll(overrideRelatedToId?: string | number | null) {
    const relatedToId = overrideRelatedToId ?? this.relatedToId;
    if (!this.companyId || !this.relatedToType || !relatedToId) {
      this.errorMessage = 'No se pudo identificar el destino de los adjuntos.';
      return;
    }

    if (this.isUploading) return;
    this.isUploading = true;
    this.errorMessage = '';

    if (this.attachedFiles.length) {
      for (const file of this.attachedFiles) {
        await this.attachmentService.uploadAttachments({
          companyId: this.companyId,
          files: [file],
          relatedToType: this.relatedToType,
          relatedToId,
          token: this.token
        });
      }
    }

    if (this.audioFile) {
      await this.attachmentService.uploadAttachments({
        companyId: this.companyId,
        files: [this.audioFile],
        relatedToType: this.relatedToType,
        relatedToId,
        isAudio: true,
        token: this.token
      });
    }

    this.attachedFiles = [];
    this.audioFile = null;
    this.isUploading = false;
    this.uploaded.emit();
  }
}
